// extracted by mini-css-extract-plugin
export var btn_qty = "pdp-module--btn_qty--OJwax";
export var carousel = "pdp-module--carousel--rhOBE";
export var carousel_cell = "pdp-module--carousel_cell--644I1";
export var formControl = "pdp-module--form-control--vaUOD";
export var pdp__h1 = "pdp-module--pdp__h1--V2F4+";
export var pdp__reviews_bg = "pdp-module--pdp__reviews_bg--BBoGg";
export var pdp__stat = "pdp-module--pdp__stat--uPYXY";
export var pdp__stat_heading = "pdp-module--pdp__stat_heading--RHqGY";
export var pdp__stat_lg = "pdp-module--pdp__stat_lg--SFw8K";